var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"top-bar-action",on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"size":"18","color":"#0c315e"}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }